import { z } from "zod"

import { HeaderButtonNotifications } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonNotifications"
import { HeaderButtonProfile } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile"
import { HeaderButtonReferAFriend } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonReferAFriend"
import type { TLoginUserData } from "@/schemas/user.schema"

// const HeaderButtonSupport = dynamic(
//   () =>
//     import("./components/HeaderButtonSupport").then(
//       (mod) => mod.HeaderButtonSupport
//     ),
//   {
//     ssr: false,
//     loading: () => <Skeleton width={rem(36)} height={rem(36)} opacity={0.2} />,
//   }
// )

const HeaderButtonTypeEnum = z.enum([
  "ReferAFriend",
  // "SupportChat",
  "Notifications",
  "Profile",
])
type THeaderButtonType = z.infer<typeof HeaderButtonTypeEnum>

interface HeaderNavBarButtonProps {
  type: THeaderButtonType
  userData?: TLoginUserData
}

export function HeaderNavBarButton({ type, userData }: HeaderNavBarButtonProps) {
  switch (type) {
    case HeaderButtonTypeEnum.Enum.ReferAFriend:
      return <HeaderButtonReferAFriend />
    case HeaderButtonTypeEnum.Enum.Notifications:
      return <HeaderButtonNotifications />
    // case HeaderButtonTypeEnum.Enum.SupportChat:
    //   return <HeaderButtonSupport />
    case HeaderButtonTypeEnum.Enum.Profile:
      return <HeaderButtonProfile userData={userData} />
    default:
      return <></>
  }
}
